import React from 'react';
import { Card } from '../Card';

interface SchoolTypeSelectionProps {
  options: string[];
  onSchoolTypeSelection: () => void;
  setSelectedSchoolType: (selectedSchoolType: string) => void;
}

const SchoolTypeSelection: React.FC<SchoolTypeSelectionProps> = ({
  options,
  onSchoolTypeSelection,
  setSelectedSchoolType,
}) => {
  function onclick(selectedSchoolLevel: string) {
    setSelectedSchoolType(selectedSchoolLevel);
    onSchoolTypeSelection();
  }
  return (
    <div className="w-full bg-white rounded-lg sm:rounded-xl px-6 py-3 sm:p-6 lg:p-8 shadow-lg">
      <div className="flex flex-col items-center gap-3 sm:gap-4 lg:gap-6 max-w-lg mx-auto">
        {options.map((option, index) => (
          <Card key={index} title={option} onClick={() => onclick(option)} />
        ))}
      </div>
    </div>
  );
};

export default SchoolTypeSelection;
